import store from '../store';

import genericApi from './genericApi';

import { setDestinationGha, setOriginGha } from '../store/actions/ghaAction';
import { setDestinationPort, setOriginPort } from '../store/actions/portAction';

import Awb from '../models/Awb';
import { AwbPartStatuses } from '../models/AwbPart';
import User from '../models/User';
import ApiResponse from '../models/ApiResponse';
import ResponseError from '../models/ResponseError';
import РroofOfDelivery from '../models/ProofOfDelivery';
import AwbDetails from '../models/AwbDetails';
import ScreeningAwbDetails from '../models/ScreeningAwbDetails';
import ShimpmentInventoryResponse from '../models/ShipmentInventoryResponse';

const awbsReqHandler = {

  getImportAwbs: (port: string, gha: number, delivered?: boolean, paid?: boolean, unpaid?: boolean, keyword?: string, sortby?: string, filterby?: string): Promise<ApiResponse<Awb[]>> => {

    const params: Array<string> = [];
    let url: string = 'awb?';

    if (port) {
      params.push(`dst_port=${port}`);
    }
    if (gha) {
      params.push(`dst_gha=${gha}`);
    }

    if (delivered != undefined)
      params.push(`delivered=${delivered}`);

    if (paid != undefined)
      params.push(`paid=${paid}`);

    if (unpaid != undefined)
      params.push(`unpaid=${unpaid}`);

    if (sortby != undefined)
      params.push(`sortby=${sortby}`);

    if (keyword != undefined && keyword != '')
      params.push(`keyword=${keyword}`);
  
    if (filterby != undefined)
      params.push(`filterby=${filterby}`);

    url += params.join('&');

    return genericApi.get(url);
  },

  getGhaAwbList: (isExport: boolean): Promise<ApiResponse<Awb[]>> => {
    return genericApi.get(`awb?isExport=${isExport}`)
  },
  getAwbPartStatuses: (): Promise<ApiResponse<AwbPartStatuses>> => {

    return genericApi.get("awb_part/available_status");
  },
  getAwb: (awbNumber: string, isExport: boolean, version?: number, isRfs?: boolean): Promise<ApiResponse<Awb>> => {

    let awbNumberArr: string[] = awbNumber.split('-');
    let url = `awb/${awbNumberArr[0]}/${awbNumberArr[1]}?isExport=${isExport}`;

    if (version) {
      url += `&version=${version}`;
    }
    if (isRfs) {
      url += `&isRfs=${isRfs}`;
    }
    return genericApi.get(url);
  },
  getFetchedAwb: (requestId: string): Promise<any> => { // TODO: type

    return genericApi.get(`awb/${requestId}`);
  },
  deleteImportPart: (id: number): Promise<ApiResponse<boolean>> => {
    return genericApi.delete(`part/${id}`);
  },
  addStorage: (code: string, number: string): Promise<ApiResponse<boolean>> => {
    return genericApi.put(`storage/${code}/${number}`);
  },
  fetchAwb: (awbNumber: string, type: string, force: boolean = false): Promise<{ request_id: string }> => {

    let awbNumberArr: string[] = awbNumber.split('-');

    return genericApi.post(`fetch/${awbNumberArr[0]}/${awbNumberArr[1]}?refresh=true&process=${type}&force=${force}`, {});
  },

  getAwbs: (awbNumber: string): Promise<ApiResponse<any>> => {

    let awbNumberArr: string[] = awbNumber.split('-');

    return genericApi.get(`awbs/${awbNumberArr[0]}/${awbNumberArr[1]}`, {});
  },
  extractAwb: function (awbNumber: string, type: string, force: boolean = false): Promise<{ awbData: Awb, requestId: string }> {

    return this.fetchAwb(awbNumber, type, force).then((reqResp) => {
      return new Promise((resolve: Function, reject: Function) => {

        let requestId = reqResp.request_id;
        if (requestId) {
          let interval = setInterval(() => {
            this.getFetchedAwb(requestId).then((resp) => {
              if (resp.status === 'success' && resp.result) {
                clearInterval(interval);
                resolve({ awbData: resp.result.awb, requestId: requestId });
              } else if (resp.status === 'failure') {
                const error: ResponseError | undefined = resp.error;
                clearInterval(interval);
                reject(error);
              };
            }, (err: any) => {
              clearInterval(interval);
              reject(err);
            });
          }, 3000);
        }
      });
    })
  },
  extractNewAwb: function (awbNumber: string, type: string, isExport: boolean, version?: number, force?: boolean): Promise<{ awbData: Awb, requestId: string }> {

    return this.getAwb(awbNumber, isExport, version).then((data: ApiResponse<Awb>) => {

      return new Promise((resolve: Function, reject: Function) => {

        const result: Awb | undefined = data.result;
        const error: ResponseError | undefined = data.error;

        if (result) {

          const user: User = store.getState().user;

          if (result.id_forwarder === user.forwarder_id) {

            let errObj: ResponseError = {
              errorCode: '',
              longDescription: 'This AWB is already added to the list!'
            };

            if (type === 'import') {

              const gha: number = result.id_gha_dst ? result.id_gha_dst : 0;
              const port: string = result.destination;

              if (store.getState().destinationPort !== port) {
                store.dispatch(setDestinationPort(port))
              };

              if (store.getState().destinationGhaId !== gha) {
                store.dispatch(setDestinationGha(gha))
              };

              reject(errObj);

            } else {

              const gha: number = result.id_gha_org ? result.id_gha_org : 0;
              const port: string = result.origin;

              if (store.getState().originPort !== port) {
                store.dispatch(setOriginPort(port));
              };

              if (store.getState().originGhaId !== gha) {
                store.dispatch(setOriginGha(gha));
              };

              reject(errObj);

            }
          } else {

            resolve({ awbData: result, requestId: '' });
          };
        }
        else if(error && error.errorCode ==='#ExportAddedToImport') {

            reject(error);

        } else if (error && (error.errorCode === '#awbNotFound')) {

          this.extractAwb(awbNumber, type, force).then((resp) => {
            resolve(resp);
          }, (err: any) => {
            reject(err);
          });
        } else {
          reject(error);
        }
      });
    })
  },
  getAwbByCodeAndNumber: (awbCode: string, awbNumber: string, isExport: boolean, version?: number): Promise<ApiResponse<Awb>> => {
    let url = `awb/${awbCode}/${awbNumber}?isExport=${isExport}`;

    if (version) {
      url += `&version=${version}`;
    }
    return genericApi.get(url);
  },
  getExportAwbs: (port: string, gha: number, delivered?: boolean, keyword?: string, sortby?: string): Promise<ApiResponse<Awb[]>> => {

    const params: Array<string> = [];
    let url: string = `awb?isExport=${true}&`;

    if (port) {
      params.push(`org_port=${port}`);
    }

    if (gha) {
      params.push(`org_gha=${gha}`);
    }
    if (delivered != undefined)
      params.push(`delivered=${delivered}`);

    if (sortby != undefined)
      params.push(`sortby=${sortby}`);

    if (keyword != undefined && keyword != '')
      params.push(`keyword=${keyword}`);

    url += params.join('&');

    return genericApi.get(url);
  },
  addAwbList: (data: Awb, edit: boolean, isExport: boolean, requestId?: string, isRfs?: boolean, version?: number, confirmInterline?: boolean): Promise<ApiResponse<Awb>> => {

    const code: string = data.code;
    const number: string = data.number;
    let url: string = `awb/${code}/${number}?fav=true&edit=${edit}&isExport=${isExport}`;

    if (requestId) {
      url += `&request_id=${requestId}`;
    };
    if (isRfs) {
      url += `&isRfs=${isRfs}`;
    };
    if (version) {
      url += `&version=${version}`;
    };
    if (confirmInterline) {
      url += `&confirmInterline=${confirmInterline}`;
    };

    return genericApi.put(url, data);
  },
  editAwb: (awb: Awb, requestId?: string, update_metadata_only?: boolean, isExport?: boolean, orderNo?: string): Promise<ApiResponse<Awb>> => {

    const code: string = awb.code;
    const number: string = awb.number;
    const version: number = awb.version;
    let url: string = `awb/${code}/${number}/${version}?`;
    let body: Awb | {} = awb;

    if (requestId) {
      url += `request_id=${requestId}&`;
    }
    if (update_metadata_only) {
      url += `update_metadata_only=${update_metadata_only}`;
    }
    if (isExport) {
      url += `isExport=${isExport}&`;
    }
    if (orderNo) {
      url += `orderNumber=${orderNo}`;
    }

    return genericApi.post(url, body);
  },
  deleteAwb: (awbCode: string, awbNumber: string): Promise<ApiResponse<boolean>> => {

    return genericApi.delete(`awblist/${awbCode}/${awbNumber}`);
  },
  getAwbPoD: (awbCode: string, awbNumber: string, version: number): Promise<ApiResponse<Array<РroofOfDelivery>>> => {

    return genericApi.get(`awb/${awbCode}/${awbNumber}/${version}/pod`)
  },
  sendProofOfDeliveryEmail: (awbCode: string, awbNumber: string, version: number, recipient: string): Promise<ApiResponse<boolean>> => {

    return genericApi.post(`awb/${awbCode}/${awbNumber}/${version}/pod/email`, { recipient });
  },

  getAwbInfo: (awbCode: string, awbNumber: string, version: number): Promise<ApiResponse<AwbDetails>> => {

    return genericApi.get(`awb/${awbCode}/${awbNumber}/details?version=${version}`);
  },

  getShipmentInventoryOrders: (type: string | null, startDate: string, endDate: string, startTime: string, endTime: string, keyword: string, version: number): Promise<ApiResponse<ShimpmentInventoryResponse>> => {

    return commonPickupOrderParams(type, startDate, endDate, startTime, endTime, keyword, version);
  }
};

export default awbsReqHandler;

function commonPickupOrderParams(type: string | null, startDate: string, endDate: string, startTime: string, endTime: string, keyword: string, version: number) {

  let url: string = `inventory/pickup_orders?`;

  if (type) {
    url = `${url}type=${type}&`;
  };

  if (startDate) {
    url = `${url}start_date=${startDate}&`;
  };

  if (endDate) {
    url = `${url}end_date=${endDate}&`;
  };

  if (startTime) {
    url = `${url}start_time=${startTime}&`;
  };

  if (endTime) {
    url = `${url}end_time=${endTime}&`;
  };

  if (keyword) {
    url = `${url}keyword=${keyword}&`;
  };
  if (version) {
    url = `${url}version=${version}&`;
  };


  return genericApi.get(url);
}